import { render, staticRenderFns } from "./BidsResponseDialog.vue?vue&type=template&id=13bda79c&"
import script from "./BidsResponseDialog.vue?vue&type=script&lang=js&"
export * from "./BidsResponseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports